export default "__VITE_ASSET__CNafFMd4__"